// ─── Drop-zone marker ─────────────────────────────────────────────────────────
// Parachute and egg: the brood's egg, coming down as a new drone — friendly
// resupply incoming, NOT a target (the bullseye vocabulary stays exclusively
// offensive: aim cells on the opponent's field). The canopy — three panels,
// split by two seams (drawn in the outline colour) from the scallop points
// to the apex — the
// shroud lines take the caller's colour; the egg is egg cream (EGG_FILL, as
// on a brood's nest) and wears exactly the canopy's stroke — none unless the
// caller outlines the icon. Greyed out (the dock's .bs__tray-icon--spent)
// the whole thing goes one silhouette colour. Drawn in a 512 box like the
// Font Awesome icon it replaced, so callers' outline strokes (style stroke /
// strokeWidth in those units, paintOrder 'stroke') ring every part alike.
export const EGG_FILL = '#f4e8c4'
export const EGG_RIM  = 'rgba(0, 0, 0, 0.78)'
const CANOPY = 'M36 196 A220 180 0 0 1 476 196 Q402.7 160 329.3 196 Q256 160 182.7 196 Q109.3 160 36 196 Z'
const LINES = [
    'M50 206 L66 200 L222 316 L208 326 Z',
    'M248 200 L264 200 L264 290 L248 290 Z',
    'M446 200 L462 206 L304 326 L290 316 Z',
]
const SEAM_W = 26
const SEAMS = ['M182.7 194 Q194 84 250 30', 'M329.3 194 Q318 84 262 30']
const EGG = 'M256 284 C311 284 344 350 344 410 C344 466 306 502 256 502 C206 502 168 466 168 410 C168 350 201 284 256 284 Z'
const SEAM_DARK = '#0a0806'

export default function DropZoneMarker({ size = 26, color = '#000000', style, className }) {
    // The seams are drawn in the icon's outline colour where the caller
    // outlines it, dark otherwise, so they read as part of the same line work.
    const seam = style?.stroke ?? SEAM_DARK
    return (
        <svg
            viewBox="0 0 512 512"
            className={className}
            fill="currentColor"
            strokeLinejoin="round"
            style={{ fontSize: size, width: '1em', height: '1em', color, display: 'block', overflow: 'visible', ...style }}
            aria-hidden="true"
            data-icon="parachute-egg"
        >
            <path data-canopy="true" d={CANOPY} />
            {SEAMS.map(d => (
                <path key={d} data-seam="true" d={d} fill="none" stroke={seam} strokeWidth={SEAM_W} strokeLinecap="round" />
            ))}
            {LINES.map(d => <path key={d} d={d} />)}
            <path data-egg-part="true" d={EGG} fill={EGG_FILL} />
        </svg>
    )
}

// ─── Parachute canopy ─────────────────────────────────────────────────────────
// Scalloped canopy with suspension lines converging below — composed over other
// glyphs (a Base-in-construction renders it above the Base's missile cluster:
// the 3rd, maturing missile is inbound).
export function ParachuteCanopy({ width = 22, color = '#000000', style }) {
    return (
        <svg
            width={width}
            height={width * 0.56}
            viewBox="0 0 32 18"
            style={{ display: 'block', ...style }}
            aria-hidden="true"
        >
            <path
                d="M1 11 A15 11 0 0 1 31 11 Q26 8.5 21 11 Q16 8.5 11 11 Q6 8.5 1 11 Z"
                fill={color}
            />
            <g stroke={color} strokeWidth="1.4" strokeLinecap="round">
                <line x1="3"  y1="12" x2="14" y2="18" />
                <line x1="16" y1="12" x2="16" y2="18" />
                <line x1="29" y1="12" x2="18" y2="18" />
            </g>
        </svg>
    )
}
